import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation-American English
      "dashboard": "Dashboard",
      "facebook": "Facebook",
      "whatsapp": "WhatsApp",
      "telegram": "Telegram",
      "instagram": "Instagram",
      "campaigns": "Campaigns",
      "chatbot": "Chatbot",
      "subscription": "Subscription",
      "analytics": "Analytics",

      // Dashboard
      "welcome": "Welcome to",
      "systemName": "social-auto.ly",
      "systemDesc": "Advanced Social Media Automation Platform",
      "facebookManager": "Facebook Manager",
      "whatsappManager": "WhatsApp Manager",
      "campaignManager": "Campaign Manager",
      "chatbotManager": "Chatbot Manager",

      // Common
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "add": "Add",
      "send": "Send",
      "connect": "Connect",
      "disconnect": "Disconnect",
      "status": "Status",
      "loading": "Loading...",
      "success": "Success",
      "error": "Error",
      "name": "Name",
      "message": "Message",
      "number": "Number",
      "type": "Type",
      "actions": "Actions",

      // WhatsApp
      "connectWhatsApp": "Connect WhatsApp",
      "scanQR": "Scan QR Code",
      "connected": "Connected",
      "disconnected": "Disconnected",
      "contacts": "Contacts",
      "groups": "Groups",
      "chats": "Chats",
      "sendMessage": "Send Message",
      "sendMedia": "Send Media",
      "sendLocation": "Send Location",
      "broadcastList": "Broadcast List",
      "messageTemplates": "Message Templates",
      "contactManagement": "Contact Management",
      "importContacts": "Import Contacts",
      "exportContacts": "Export Contacts",
      "archiveChat": "Archive Chat",
      "pinChat": "Pin Chat",
      "muteChat": "Mute Chat",
      "viewContacts": "View Contacts",
      "viewGroups": "View Groups",
      "createBroadcast": "Create Broadcast",
      "messageStats": "Message Statistics",

      // Facebook
      "addAccount": "Add Account",
      "accounts": "Accounts",
      "cookies": "Cookies",
      "scrapePost": "Scrape Post",
      "postUrl": "Post URL",
      "extractAds": "Extract Ads",
      "sendMessenger": "Send Messenger",
      "autoLike": "Auto Like",
      "autoComment": "Auto Comment",

      // Campaigns
      "createCampaign": "Create Campaign",
      "campaignName": "Campaign Name",
      "campaignType": "Campaign Type",
      "targetGroup": "Target Group",
      "schedule": "Schedule",
      "delay": "Delay",
      "minDelay": "Min Delay (seconds)",
      "maxDelay": "Max Delay (seconds)",

      // Chatbot
      "createRule": "Create Rule",
      "keyword": "Keyword",
      "response": "Response",
      "platform": "Platform",
      "enabled": "Enabled",

      // Auth
      "login": "Login",
      "register": "Register",
      "logout": "Logout",
      "email": "Email",
      "password": "Password",
      "username": "Username",
      "signIn": "Sign In",
      "signUp": "Sign Up",
      "dontHaveAccount": "Don't have an account?",
      "alreadyHaveAccount": "Already have an account?",
    }
  },
  ar: {
    translation: {
      // Navigation
      "dashboard": "لوحة التحكم",
      "facebook": "فيسبوك",
      "whatsapp": "واتساب",
      "telegram": "تيليجرام",
      "instagram": "انستغرام",
      "campaigns": "الحملات",
      "chatbot": "الشات بوت",
      "subscription": "الاشتراك",
      "analytics": "التحليلات",

      // Dashboard
      "welcome": "مرحباً بك في",
      "systemName": "سوشيال أوتو",
      "systemDesc": "منصة متقدمة لأتمتة وسائل التواصل الاجتماعي",
      "facebookManager": "مدير فيسبوك",
      "whatsappManager": "مدير واتساب",
      "campaignManager": "مدير الحملات",
      "chatbotManager": "مدير الشات بوت",

      // Common
      "save": "حفظ",
      "cancel": "إلغاء",
      "delete": "حذف",
      "edit": "تعديل",
      "add": "إضافة",
      "send": "إرسال",
      "connect": "اتصال",
      "disconnect": "قطع الاتصال",
      "status": "الحالة",
      "loading": "جاري التحميل...",
      "success": "نجح",
      "error": "خطأ",
      "name": "الاسم",
      "message": "الرسالة",
      "number": "الرقم",
      "type": "النوع",
      "actions": "الإجراءات",

      // WhatsApp
      "connectWhatsApp": "ربط واتساب",
      "scanQR": "امسح رمز الاستجابة السريعة", // Updated from "مسح رمز QR"
      "connected": "متصل",
      "disconnected": "غير متصل",
      "contacts": "جهات الاتصال",
      "groups": "المجموعات",
      "chats": "المحادثات",
      "sendMessage": "إرسال رسالة",
      "sendMedia": "إرسال ملف",
      "sendLocation": "إرسال موقع",
      "broadcastList": "قائمة البث",
      "messageTemplates": "قوالب الرسائل",
      "contactManagement": "إدارة جهات الاتصال",
      "importContacts": "استيراد جهات الاتصال",
      "exportContacts": "تصدير جهات الاتصال",
      "archiveChat": "أرشفة المحادثة",
      "pinChat": "تثبيت المحادثة",
      "muteChat": "كتم المحادثة",
      "viewContacts": "عرض جهات الاتصال",
      "viewGroups": "عرض المجموعات",
      "createBroadcast": "إنشاء قائمة بث",
      "messageStats": "إحصائيات الرسائل",

      // Facebook
      "addAccount": "إضافة حساب",
      "accounts": "الحسابات",
      "cookies": "الكوكيز",
      "scrapePost": "استخراج المنشور",
      "postUrl": "رابط المنشور",
      "extractAds": "استخراج الإعلانات",
      "sendMessenger": "إرسال ماسنجر",
      "autoLike": "لايك تلقائي",
      "autoComment": "تعليق تلقائي",

      // Campaigns
      "createCampaign": "إنشاء حملة",
      "campaignName": "اسم الحملة",
      "campaignType": "نوع الحملة",
      "targetGroup": "المجموعة المستهدفة",
      "schedule": "الجدولة",
      "delay": "التأخير",
      "minDelay": "الحد الأدنى للتأخير (ثانية)",
      "maxDelay": "الحد الأقصى للتأخير (ثانية)",

      // Chatbot
      "createRule": "إنشاء قاعدة",
      "keyword": "الكلمة المفتاحية",
      "response": "الرد",
      "platform": "المنصة",
      "enabled": "مفعل",

      // Auth
      "login": "تسجيل الدخول",
      "register": "إنشاء حساب",
      "logout": "تسجيل الخروج",
      "email": "البريد الإلكتروني",
      "password": "كلمة المرور",
      "username": "اسم المستخدم",
      "signIn": "دخول",
      "signUp": "تسجيل",
      "dontHaveAccount": "ليس لديك حساب؟",
      "alreadyHaveAccount": "لديك حساب بالفعل؟",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ar',
    lng: 'ar', // Default to Arabic
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
